module.exports = __webpack_public_path__ + "static/app/img/vendoscope-logo.b5d46f6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/vendoscope-logo.png
// module id = MJKu
// module chunks = 1